import { bulkUserUploadIcon } from "assets/icons/svgIcons";

export default [
  {
    id: "Upload Users",
    title: "Upload Users",
    icon: bulkUserUploadIcon,
    pageTitle: "Upload Users",
    navLink: "/uploadUsers",
    type: "item",
    isActive: true,
    permissions: ["super_admin"],
  },
];